<template>
  <div class="Wdgt-Content-Capital-Info">
    <p class="Wdgt-Content-Capital-Info__ttl">
    </p>
    <BlockDropsDescription />
  </div>
</template>

<script setup>
  import DropscapitalLogo from "@svg/DropscapitalLogo.vue";
  import BlockDropsDescription from "@ui/Blocks/BlockDropsDescription/BlockDropsDescription.vue";
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>
